import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";
import { ValidationResult } from "features/common/models/ValidationResult";
import Projeto from "features/projetos/models/Projeto";

async function createProjeto(projeto: Projeto): Promise<IResponse<ValidationResult>> {
  return await axios.post('/Projetos/Criar', projeto);
}

export default createProjeto;